import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, request, toast } from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { PHARMACY_REPORT_TYPE } from '../../../../../constants/dropdown';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';

export const Itemwisesalereortregister = () => {
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const { pathname } = useLocation();
  const [openPrint, setOpenPrint] = useState(false);
  const [productDropdown, setProductDropdown] = useState([]);

  // Form handling using react-hook-form and Yup for validation
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required('From date is required'),
        to_date: Yup.string().required('To date is required')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0], // Default to today
      to_date: new Date().toISOString().split('T')[0] // Default to today
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;

const onSubmit = () => {
  const productId = watch('product');
  const startDate = watch('from_date');
  const endDate = watch('to_date');
  const url = `/print${pathname}?productId=${encodeURIComponent(productId)}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  console.log("Generated URL:", url); 
  window.open(url, '_blank');
};

  const getProductDropdown = useCallback(async () => {
    const data = await axios.get(`${BASE_URL}/product-master/dropdown`);
    if (data?.data.data) {
      setProductDropdown(data.data.data);
    }
  }, []);

  useEffect(() => {
    getProductDropdown();
  }, []);

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Item Wise Sale Report Register
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                    onClick={() => 
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({ 
                        productId: watch('product'), 
                        from_date: watch('from_date'), 
                        to_date: watch('to_date') 
                      })}`, 
                      '_blank'
                    )
                  }
                >
                  View Report
                </Button>
                <Button variant="contained" onClick={() => reset()}>
                  Exit
                </Button>
              </Stack>
            </Stack>

            {/* Date Range Form Inputs */}
            <Grid container spacing={2}>
              <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Product Name</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    name="product"
                    menus={productDropdown.map((data) => ({ ...data, name: data?.main.name }))}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                </Stack>
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
